import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { OcrService } from './ocr.service';






@Component({
  selector: 'app-nxt-ocr',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './nxt-ocr.component.html',
  styleUrl: './nxt-ocr.component.scss'
})
export class NxtOcrComponent  implements OnInit, OnDestroy {
  @ViewChild('videoElement', { static: true }) videoElement!: ElementRef;
  @ViewChild('canvasElement', { static: true }) canvasElement!: ElementRef;
  
  video!: HTMLVideoElement;
  canvas!: HTMLCanvasElement;
  context!: CanvasRenderingContext2D | null;
  recognizedText: string[] = [];
  processing: boolean = false;
  intervalId: any;
  

  constructor(private ocr: OcrService){}


  ngOnInit() {
    this.video = this.videoElement.nativeElement;
    this.canvas = this.canvasElement.nativeElement;
    this.context = this.canvas.getContext('2d');
    this.startCamera();

    //this.startScanning()
  }

  async startCamera() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
      this.video.srcObject = stream;
      this.video.play();
    } catch (err) {
      console.error('Error accessing camera:', err);
    }
  }





  captureFrame() {
    this.processing = true;
    if (!this.context) return;
    this.canvas.width = this.video.videoWidth;
    this.canvas.height = this.video.videoHeight;
    this.context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
    this.processImage();
  }

  processImage() {
    if (!this.context) return;



    
    // Convert the frame to grayscale and increase contrast
    let imageData = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    //this.enhanceImage(imageData);
    this.context.putImageData(imageData, 0, 0);
  
    // Convert the enhanced image to a Data URL
    const imageDataUrl = this.canvas.toDataURL('image/png');

    this.ocr.OCR(imageDataUrl).subscribe(ret=>{
      this.recognizedText = ret.text;

      this.processing = false;
    })
  
    //make request
  }
  

  enhanceImage(imageData: ImageData) {
    let data = imageData.data;
    
    for (let i = 0; i < data.length; i += 4) {
      // Convert to grayscale
      let avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
      
      // Increase contrast (simple thresholding)
      avg = avg > 128 ? 255 : 0;
  
      data[i] = data[i + 1] = data[i + 2] = avg; // Set RGB to grayscale value
    }
  }
  

  ngOnDestroy() {
    if (this.video.srcObject) {
      (this.video.srcObject as MediaStream).getTracks().forEach(track => track.stop());
    }
    clearInterval(this.intervalId);
  }
}